<template>
    <div
        class="company-carousel-item m-auto d-flex align-items-center justify-content-center"
    >
        <img class="p-2 company-logo" :src="imageUrl" :alt="imageAlt" />
    </div>
</template>

<script>
export default {
    name: 'CompanyItem',
    props: {
        imageUrl: String,
        imageAlt: String,
        link: String,
    },
};
</script>

<style scoped>
.company-carousel-item {
    border: 2px solid rgb(211, 211, 211);
    width: 110px;
    height: 110px;
    background-color: #f0efee;
    border-radius: var(--border-radius);
}

.company-logo {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
}
</style>
